import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { HomePageSection } from "../HomePageSection";
import { PsModalTuner } from "stencilSetup";
import { IntegrationsResponseDto, useConfigurationQuery, useMyIntegrationsQuery } from 'theSource/queries';
import { MarketPlaceCard } from "./components/MarketPlaceCard";
import { selectIsAdmin } from '../../../../theSource/features';
import { useEnrollmentProfileQuery } from '../../../../enrollment/queries';

export function IntegrationMarketPlace() {
    const { t } = useTranslation("pages.home");
    const { integrationsResponse } = useMyIntegrationsQuery();
    const { configuration } = useConfigurationQuery();
    const isAdmin = useSelector(selectIsAdmin);
    const [modalDetails, setModalDetails] = useState<{ carrierName: string, bodyText: string, note: string }>({
        carrierName: '',
        bodyText: '',
        note: ''
    });
    const integrations = integrationsResponse as IntegrationsResponseDto | undefined;

  const { subscriber } = useEnrollmentProfileQuery({ lumosEnabled: true });
  const testEmployee = subscriber?.data?.test_employee?.value;

    function redirectToPartner({ carrierLookupCode, ssoProtocol }: { carrierLookupCode: string, ssoProtocol: string }) {
        const url = `${configuration?.apiHost}/v1/self_service/handle_sso?carrier_lookup_code=${carrierLookupCode}&sso_protocol=${ssoProtocol}`;
        window.open(url, '_blank');
    }

    if (!integrations || integrations?.data.length === 0) {
        return null;
    }

    return (
        <HomePageSection title={t("integrationMarketplace.title")} additionalClasses="order-md-6 order-6">
            <p className="body2">{t("integrationMarketplace.description")}</p>

            <div className="row w-100">
                {
                    integrations?.data.map((integration, index) => {
                        return (
                            <div className="col-12 col-md-4 col-lg-6 p-2" key={index}>
                                <MarketPlaceCard
                                    key={integration.carrier_lookup_code}
                                    integration={integration}
                                    handleModalPopup={setModalDetails}
                                    redirectToPartner={redirectToPartner}
                                    isSubscriber={!isAdmin}
                                    isTestEmployee={testEmployee}
                                />
                            </div>
                        );
                    })
                }
            </div>

            <PsModalTuner
                modalId="member-portal-modal"
                modalTitle={modalDetails.carrierName || t('memberPortal')}
            >
                <p className="body2">{modalDetails.bodyText}</p>
                <p className="body2 text-secondary">{modalDetails.note && `Notes: ${modalDetails.note}`}</p>
            </PsModalTuner>
        </HomePageSection>
    );
}
